export default {
  '关键字':'關鍵字',
  '请输入名称关键字':'請輸入名稱關鍵字',
  '新增计划':'新增計劃',
  '管理人员':'管理人員',
  '已选':'已選',
  '清空':'清空',
  '计划名称':'計劃名稱',
  '个性化训练周期':'個性化訓練週期',
  '持续时长':'持續時長',
  '天':'天',
  '个性化训练人数':'個性化訓練人數',
  '是否删除':'是否刪除',
  '删除后该计划不可再查看':'刪除後該計劃不可再查看',
  '删除成功。':'刪除成功。',
  '是否提前结束':'是否提前結束',
  '结束后立即生效':'結束後立即生效',
  '结束成功。':'結束成功。',
  '操作成功。':'操作成功。',
  '人员不能为空！':'人員不能為空！',
  '请选择班级':'請選擇班級',

  '计划日期':'計劃日期',
  '运动日期':'運動日期',
  '学生姓名':'學生姓名',
  '年级':'年級',
  '强度':'強度',
  '个':'個',
  '秒':'秒',
  '填写基本信息':'填寫基本資訊',
  '配置运动项目':'配置運動項目',
  '发布个性化训练计划':'發佈個性化訓練計劃',
  '查看个性化训练计划':'查看個性化訓練計劃',
  '编辑个性化训练计划':'編輯個性化訓練計劃',
  '请添加项目！':'請添加項目！',
  '编辑成功':'編輯成功',
  '新增成功':'新增成功',
  '返回后数据不会保存':'返回後數據不會保存',
  '基础信息':'基礎資訊',
  '复制其他计划':'複製其他計劃',
  '请选择':'請選擇',
  '请输入计划名称，1~20个字':'請輸入計劃名稱，1~20個字',
  '选择图标':'選擇圖標',
  '图标':'圖標',
  '参训人员':'參訓人員',
  '添加':'添加',
  '请输入描述':'請輸入描述',
  '请输入计划名称':'請輸入計劃名稱',
  '请选择图标':'請選擇圖標',
  '请选择参训人员':'請選擇參訓人員',
  '配置项目':'配置項目',
  '周期':'週期',
  '共计':'共計',
  '天':'天',
  '暂无':'暫無',
  '个项目':'個項目',
  '当前选中日期':'當前選中日期',
  '添加项目':'添加項目',
  '复制其他日期':'複製其他日期',
  '选择复制日期':'選擇複製日期',
  '请选择日期':'請選擇日期',
  '选择项目':'選擇項目',
  '运动方式':'運動方式',
  '支持特殊项目':'支援特殊項目',
  '分':'分',
  '秒':'秒',

  '请选择运动项目':'請選擇運動項目',
  '请填写运动强度':'請填寫運動強度',
  '运动强度填写错误':'運動強度填寫錯誤',

  '项目名':'項目名',
  '运动强度':'運動強度',
  '周一':'週一',
  '周二':'週二',
  '周三':'週三',
  '周四':'週四',
  '周五':'週五',
  '周六':'週六',
  '周日':'週日',

  '请选择周期':'請選擇週期',
  '是否清空本日项目':'是否清空本日項目',
  '所选日期没有数据！':'所選日期沒有數據！',

  '用户列表':'用戶列表',
  '未开始':'未開始',
  '进行中':'進行中',
  '已结束':'已結束',

  '确认要返回吗？':'確認要返回嗎？!',
}